import { Container, Row, Col } from "react-bootstrap";
import NavigationBar from "../components/navigationbar";
import Footer from "../components/footer";
import education from "../assets/education.png";
import tutoring from "../assets/tutoring.jpg";
import quran from "../assets/quran.png";


const Education = () => {
    return (
        <div className="position-relative">
            <NavigationBar />

            <div
                style={{
                    backgroundImage: `url(${education})`,
                    backgroundSize: "110% ",
                    backgroundPosition: "bottom",
                    fontFamily: "Lora, serif",
                    height: "35vh",
                }}
            >
                <Container>
                    <div style={{ textAlign: "center", marginBottom: "1 rem" }} className="pt-3 pb-2">
                        <h4>Greater Austin Muslim Relief Committee</h4>
                    </div>

                    <div
                        className="d-flex flex-column flex-md-row align-items-start justify-content-between"
                    >
                        <Col>
                            <div style={{ flex: 1, minWidth: "280px" }}>
                                <h1 className="fw-bold mb-2">Educational Programs: </h1>
                                <h2 className=" mb-3">Accessible education programs in English, Quran, and technology—helping children build skills and confidence for the future.</h2>


                            </div>
                        </Col>
                        <Col>
                        </Col>

                    </div>
                </Container>
            </div>

            <Container className="my-4">
                <Row>
                    <Col>
                        <h2>Tutoring </h2>
                        <p>We provide English tutoring to Quran students of all ages, focusing on more than just grammar. Our tutors help students learn how to read, write, speak, and engage in everyday conversational English. This includes important life lessons like classroom rules, personal hygiene, and conversational manners.
                        </p>
                        <p>
                            Additionally, we offer tutoring in specific subjects as needed and provide college guidance to support academic success beyond language skills.</p>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center">
                        <img
                            src={tutoring}
                            alt="tutoring"
                            style={{
                                width: "80%",
                                height: "auto",
                                maxHeight: "300px",
                                objectFit: "cover",
                            }}
                        />
                    </Col>
                </Row>
                <Row className="my-5">
                    <Col>
                        <h2>Quran Classes</h2>
                        <p>Our Quran classes equip children with the tools to read, understand, and live by its teachings. The goal is not only to learn the faith but to develop strong character.</p>
                        <p>We strive to make the Quran easily accessible to all children so everyone can learn to read and understand its message.</p>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center">
                        <img
                            src={quran}
                            alt="quran"
                            style={{
                                width: "80%",
                                height: "auto",
                                maxHeight: "300px",
                                objectFit: "cover",
                            }}
                        />
                    </Col>
                </Row>

            </Container>

            <Footer />
        </div>
    );
};

export default Education;
